import React, { forwardRef, useRef, useEffect } from "react";
import './GridCategoryVideos.css';
import VideoCard from "../VideoCard/VideoCard";

const GridCategoryVideos = forwardRef(({ data, hidden }, ref) => {
  const episodeRefs = useRef([]);

  useEffect(() => {
    // Reset refs on mount
    episodeRefs.current = [];
  }, [data]);

  return (
    <div ref={ref} hidden={hidden}>
      <div className="gridlayout mt-4">
        <div className="row">
          {data.series.map((series) =>
            series.episodes.map((episode) => (
              <div key={episode.episode_id} className="col-3 p-2">
                <VideoCard
                  episode={episode}
                  series={series}
                  ref={(el) => el && episodeRefs.current.push(el)}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
    
});

export default GridCategoryVideos;
